import HeaderInfoDiscoverComponent from "./HeaderInfoDiscoverComponent";

export default HeaderInfoDiscoverComponent;